import React, { useEffect, useState } from 'react'
import {  ButtonDropdown,  DropdownMenu, DropdownToggle,  Label } from 'reactstrap'
import { CloseIcon, FilterIcon, filterBlackIcon } from '../../../assets/images'
import { RadioTypes } from '../../../commonTypes/universalTypes'
import { RadioContainer, ToggleSwitch } from '../../commons'
import "./filter.scss"
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import DatePicker from 'react-datepicker';
import { CalenderIcon } from '../../Icon';
import moment from 'moment';




type AppProps = {
  attachment:string;
  approved:string;
  settingApproval: (approvalData: string | undefined, setApproval: any) => void,
  settingAttachment: (approvalData: string | undefined, setApproval: any) => void,
  setClearFilter:React.Dispatch<React.SetStateAction<boolean>>;
  setAttachment: React.Dispatch<React.SetStateAction<string>>;
  setApproved: React.Dispatch<React.SetStateAction<string>>;
  setData:any;
  handleDeleteFiltersInHistory:()=>void;
  setOffset:React.Dispatch<React.SetStateAction<number>>;
  approvalValue:string;
  attachmentValue:string;
  setApprovalValue:React.Dispatch<React.SetStateAction<string>>;
  setAttachmentValue:React.Dispatch<React.SetStateAction<string>>;
  comment:string;
  setComment:React.Dispatch<React.SetStateAction<string>>;
  commentValue:string;
  setCommentValue:React.Dispatch<React.SetStateAction<string>>;
  settingComment:(approvalData: string | undefined, setApproval: any) => void,
  filterStartDate: string;
  filterEndDate: string;
  setFilterStartDate: React.Dispatch<React.SetStateAction<string>>;
  setFilterEndDate: React.Dispatch<React.SetStateAction<string>>;
  setFilterEndDateValue:React.Dispatch<React.SetStateAction<string>>;
  setFilterStartDateValue:React.Dispatch<React.SetStateAction<string>>;
  filterStartDateValue:string;
  filterEndDateValue:string;
  filterInvoiceStartDate:string;
  filterInvoiceEndDate:string;
  setFilterInvoiceEndDate:React.Dispatch<React.SetStateAction<string>>;
  setFilterInvoiceStartDate:React.Dispatch<React.SetStateAction<string>>;
  filterInvoiceStartDateValue:string;
  filterInvoiceEndDateValue:string;
  setFilterInvoiceEndDateValue:React.Dispatch<React.SetStateAction<string>>;
  setFilterInvoiceStartDateValue:React.Dispatch<React.SetStateAction<string>>;
  radioValue:any;
  setRadioValue:any;
  history:any;
  isOCRFilter?:boolean;
  setIsOCRFilter?:React.Dispatch<React.SetStateAction<boolean>>;
  isOCRFilterValue?:boolean;
  setIsOCRFilterValue?:React.Dispatch<React.SetStateAction<boolean>>;
}

export const APPROVAL_RADIO_OPTIONS: RadioTypes[] = [

  {
    id: "1",
    _id:"App_1",
    name: "Approved",
  },
  {
    id: "0",
    _id:"App_0",
    name: "Unapproved",
  },
  {
    id: "2",
    _id:"App_2",
    name: "Approved By Me",
  },
  {
    id: "3",
    _id:"App_3",
    name: "Approved By Others",
  },
];

export const ATTACHMENT_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id:"Att_1",
    name: "With File Attachment",
  },
  {
    id: "0",
    _id:"Att_0",
    name: "Without File Attachment",
  },
]
export const COMMENT_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id:"Comm_1",
    name: "With Comment",
  },
  {
    id: "0",
    _id:"Comm_0",
    name: "Without Comment",
  },
]

export const DATE_FILTER_OPTION :RadioTypes[]=[
  {
    id:"1",
    _id:"Creation_date",
    name: "Invoice Creation Date"
  },
  {
    id:"2",
    _id:"Invoice_date",
    name: "Invoice Date"
  }
]
const Filter = ({
  settingApproval,
  settingAttachment,
  setAttachment,
  setApproved,
  setClearFilter,
  setOffset,
  approvalValue,
  attachmentValue,
  setApprovalValue,
  setAttachmentValue,
  handleDeleteFiltersInHistory,
  attachment,
  approved,
  setData,
  comment,
  setComment,
  commentValue,
  setCommentValue,
  settingComment,
  filterStartDate,
  filterEndDate,
  setFilterEndDate,
  setFilterStartDate,
  setFilterEndDateValue,
  setFilterStartDateValue,
  filterStartDateValue,
  filterEndDateValue,
  filterInvoiceStartDate,
  filterInvoiceEndDate,
  setFilterInvoiceEndDate,
  setFilterInvoiceStartDate,
  // 
  filterInvoiceStartDateValue,
  filterInvoiceEndDateValue,
  setFilterInvoiceEndDateValue,
  setFilterInvoiceStartDateValue,
  radioValue,
  setRadioValue,
  history,
  setIsOCRFilter,
  isOCRFilter,
  isOCRFilterValue,
setIsOCRFilterValue
}: AppProps) => {
  // const [radioValue, setRadioValue] = useState(DATE_FILTER_OPTION[0].id);

  const [toggle, setToggle] = useState<boolean>(false)
  const [isApplyDisabled, setIsApplyDisabled] = useState<boolean>(false);
 
  useEffect(() => {
    if ((filterStartDateValue && !filterEndDateValue) || (filterInvoiceStartDateValue && !filterInvoiceEndDateValue)) {
      setIsApplyDisabled(true);
    } else {
      setIsApplyDisabled(false);
    }
  }, [filterStartDateValue, filterEndDateValue, filterInvoiceStartDateValue, filterInvoiceEndDateValue]);

  const handleSetApprovalRadioValue = (radioValue: string) => {
    setApprovalValue(radioValue);
  };

  const handleSetAttachmentRadioValue = (radioValue: string) => {
    setAttachmentValue(radioValue);
  }
  const handleSetCommentRadioValue = (radioValue:string)=> {
    setCommentValue(radioValue)
  }

  const handleSetRadioValue = (data: string) => {
    setRadioValue(data);
    setFilterStartDateValue("");
    setFilterEndDateValue("");
    setFilterInvoiceStartDateValue("");
    setFilterInvoiceEndDateValue("");
  };
  const handleSubmit = () => {
    settingApproval(approvalValue, setApproved)
    settingAttachment(attachmentValue, setAttachment)
    settingComment(commentValue , setComment)
    setClearFilter(false)
    setFilterStartDate(filterStartDateValue)
    setFilterEndDate(filterEndDateValue)
    setFilterInvoiceStartDate(filterInvoiceStartDateValue)
    setFilterInvoiceEndDate(filterInvoiceEndDateValue)
   if (setIsOCRFilterValue && isOCRFilter) {
     setIsOCRFilterValue(isOCRFilter);
   }
    delete history?.location?.state?.expenseAttachement
    delete history?.location?.state?.expenseApproval
    delete history?.location?.state?.revenueAttachement
    delete history?.location?.state?.revenueApproval
    delete history?.location?.state?.expenseComment
    delete history?.location?.state?.revenueComment
    delete history?.location?.state?.expensestartDate
    delete history?.location?.state?.revenuestartDate
    delete history?.location?.state?.expenseendDate
    delete history?.location?.state?.revenueendDate
    delete history?.location?.state?.expenseInvoiceStartDate
    delete history?.location?.state?.revenueInvoiceStartDate
    delete history?.location?.state?.expenseInvoiceEndDate
    delete history?.location?.state?.revenueInvoiceEndDate
    delete history?.location?.state?.otherStartDate
    delete history?.location?.state?.otherEndDate
    delete history?.location?.state?.otherInvoiceStartDate
    delete history?.location?.state?.otherInvoiceEndDate
    delete history?.location?.state?.otherRadioValue
    delete history?.location?.state?.otherAttachement
    delete history?.location?.state?.otherApproval
    delete history?.location?.state?.radioValue
    delete history?.location?.state?.isOCRFilter
  }

  const filterEndDateChange = (date: any) => {
    if (date !== "Invalid date") {
        setFilterEndDateValue(date)
    }
    else {
        setFilterEndDateValue("")
    }
}
const filterStartDateChange = (date: any) => {
    if (date == "Invalid date") {
        setFilterEndDateValue("")
        setFilterStartDateValue("")
    }
    else {
      setFilterStartDateValue(date)
      setFilterEndDateValue("")
    }
}

const filterInvoiceEndDateChange = (date: any) => {
  if (date !== "Invalid date") {
    setFilterInvoiceEndDateValue(date)
  }
  else {
    setFilterInvoiceEndDateValue("")
  }
}
const filterInvoiceStartDateChange = (date: any) => {
  if (date == "Invalid date") {
    setFilterInvoiceStartDateValue("")
    setFilterInvoiceEndDateValue("")
  }
  else {
    setFilterInvoiceStartDateValue(date)
    setFilterInvoiceEndDateValue("")
  }
}
// 

  const clearFilter = () => {
    setApprovalValue("")
    setAttachmentValue("")
    setAttachment("")
    setComment("")
    setCommentValue('')
    setFilterEndDate("")
    setFilterStartDate("")
    setApproved("")
    setOffset(0)
    setFilterEndDateValue("")
    setFilterEndDate("")
    setFilterStartDate("")
    setFilterStartDateValue("")
    setFilterInvoiceEndDate("")
    setFilterInvoiceStartDate("")
    setFilterInvoiceEndDateValue("")
    setFilterInvoiceStartDateValue("")
    handleDeleteFiltersInHistory && handleDeleteFiltersInHistory()
    setIsOCRFilterValue&& setIsOCRFilterValue(false);
    setIsOCRFilter && setIsOCRFilter(false);
    setClearFilter(true);
  }

  const resetFilterData=()=>{
    setApprovalValue(approved)
    setAttachmentValue(attachment)
    setCommentValue(comment)
    setFilterStartDateValue(filterStartDate)
    setFilterEndDateValue(filterEndDate)
    setFilterInvoiceStartDateValue(filterInvoiceStartDate)
    setFilterInvoiceEndDateValue(filterInvoiceEndDate)
    handleDeleteFiltersInHistory && handleDeleteFiltersInHistory()
   setIsOCRFilterValue && typeof isOCRFilter === "boolean" && setIsOCRFilterValue(isOCRFilter)
   setIsOCRFilter && typeof isOCRFilterValue === "boolean" && setIsOCRFilter(isOCRFilterValue);
  }

  const handleToggleOCR = () => {
   setIsOCRFilter&& setIsOCRFilter(!isOCRFilter);
  }

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        resetFilterData();
        setToggle(!toggle);
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-filter-invoice">Filter</Tooltip>}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle
              ? {
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  backgroundColor: "#fff6f5",
                }
              : { border: "1px solid#bfcbe1" }
          }
          outline
        >
          <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />{" "}
          <span
            className={
              (approvalValue ||
                attachmentValue ||
                commentValue ||
                filterStartDateValue ||
                filterInvoiceStartDateValue ||
                isOCRFilterValue)
                ? "filter-count"
                : undefined
            }
          >
            {/* <span>{(approvalValue && attachmentValue && commentValue && filterStartDateValue && filterEndDateValue) ? 5 : (approvalValue || attachmentValue || commentValue  || filterEndDateValue || filterStartDateValue) ? 1 : "" }</span> */}
            <span>
              {[
                approvalValue,
                attachmentValue,
                commentValue,
                filterStartDateValue,
                filterInvoiceStartDateValue,
                isOCRFilterValue
              ].filter(Boolean).length || ""}
            </span>
          </span>
        </DropdownToggle>
      </OverlayTrigger>

      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                setClearFilter(false);
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />
          <h4 className="mb-2 mt-3">Date</h4>
          <div>
            <RadioContainer
              optionsList={DATE_FILTER_OPTION}
              handleSetRadioValue={handleSetRadioValue}
              radioValue={radioValue}
              alignment="horizontal"
            />
          </div>
          {
            <>
              {radioValue === "1" ? (
                <div className="row mt-2">
                  <div className="d-flex">
                    <div className="form-group col-md-6">
                      <div className="date-picker-wraper mr-0 position-relative">
                        <Label
                          className="mb-1 p-0 w-100"
                          style={{ fontSize: "14px" }}
                        >
                          Start Date
                          <DatePicker
                            dateFormat="dd-MM-yyyy"
                            selected={
                              filterStartDateValue
                                ? new Date(
                                    moment(
                                      `${filterStartDateValue}T00:00:00`,
                                      "YYYY-MM-DD"
                                    ).format("YYYY-MM-DD[T]HH:mm:ss")
                                  )
                                : null
                            }
                            onChange={(e: any) => {
                              filterStartDateChange(
                                moment(e).format("YYYY-MM-DD")
                              );
                            }}
                            fixedHeight
                            showMonthDropdown
                            showYearDropdown
                            name="filterStartDate"
                            placeholderText="Select"
                            className="form-control"
                          />
                          <span
                            className="calender-icon"
                            style={{
                              top: "28px",
                              right: "4px",
                              cursor: "pointer",
                              position: "absolute",
                            }}
                          >
                            <CalenderIcon />
                          </span>
                        </Label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="date-picker-wraper mr-0">
                          <Label
                            className="mb-1 p-0 w-100"
                            style={{ fontSize: "14px" }}
                          >
                            End Date
                            <DatePicker
                              dateFormat="dd-MM-yyyy"
                              selected={
                                filterEndDateValue
                                  ? new Date(
                                      moment(
                                        `${filterEndDateValue}T00:00:00`,
                                        "YYYY-MM-DD"
                                      ).format("YYYY-MM-DD[T]HH:mm:ss")
                                    )
                                  : null
                              }
                              onChange={(e: any) => {
                                filterEndDateChange(
                                  moment(e).format("YYYY-MM-DD")
                                );
                              }}
                              fixedHeight
                              showMonthDropdown
                              showYearDropdown
                              name="filterEndDate"
                              placeholderText="Select"
                              className="form-control"
                              disabled={!filterStartDateValue}
                              minDate={
                                filterStartDateValue
                                  ? new Date(
                                      moment(
                                        `${filterStartDateValue}T00:00:00`,
                                        "YYYY-MM-DD"
                                      ).format("YYYY-MM-DD[T]HH:mm:ss")
                                    )
                                  : null
                              }
                            />
                            <span
                              className="calender-icon"
                              style={{
                                top: "28px",
                                right: "20px",
                                cursor: "pointer",
                              }}
                            >
                              <CalenderIcon />
                            </span>
                          </Label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row mt-2">
                  <div className="d-flex">
                    <div className="form-group col-md-6">
                      <div className="date-picker-wraper mr-0 position-relative">
                        <Label
                          className="mb-1 p-0 w-100"
                          style={{ fontSize: "14px" }}
                        >
                          Start Date
                          <DatePicker
                            dateFormat="dd-MM-yyyy"
                            selected={
                              filterInvoiceStartDateValue
                                ? new Date(
                                    moment(
                                      `${filterInvoiceStartDateValue}T00:00:00`,
                                      "YYYY-MM-DD"
                                    ).format("YYYY-MM-DD[T]HH:mm:ss")
                                  )
                                : null
                            }
                            onChange={(e: any) => {
                              filterInvoiceStartDateChange(
                                moment(e).format("YYYY-MM-DD")
                              );
                            }}
                            fixedHeight
                            showMonthDropdown
                            showYearDropdown
                            name="filterStartDate"
                            placeholderText="Select"
                            className="form-control"
                          />
                          <span
                            className="calender-icon"
                            style={{
                              top: "28px",
                              right: "4px",
                              cursor: "pointer",
                              position: "absolute",
                            }}
                          >
                            <CalenderIcon />
                          </span>
                        </Label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="date-picker-wraper mr-0">
                          <Label
                            className="mb-1 p-0 w-100"
                            style={{ fontSize: "14px" }}
                          >
                            End Date
                            <DatePicker
                              dateFormat="dd-MM-yyyy"
                              selected={
                                filterInvoiceEndDateValue
                                  ? new Date(
                                      moment(
                                        `${filterInvoiceEndDateValue}T00:00:00`,
                                        "YYYY-MM-DD"
                                      ).format("YYYY-MM-DD[T]HH:mm:ss")
                                    )
                                  : null
                              }
                              onChange={(e: any) => {
                                filterInvoiceEndDateChange(
                                  moment(e).format("YYYY-MM-DD")
                                );
                              }}
                              fixedHeight
                              showMonthDropdown
                              showYearDropdown
                              name="filterEndDate"
                              placeholderText="Select"
                              className="form-control"
                              disabled={!filterInvoiceStartDateValue}
                              minDate={
                                filterInvoiceStartDateValue
                                  ? new Date(
                                      moment(
                                        `${filterInvoiceStartDateValue}T00:00:00`,
                                        "YYYY-MM-DD"
                                      ).format("YYYY-MM-DD[T]HH:mm:ss")
                                    )
                                  : null
                              }
                            />
                            <span
                              className="calender-icon"
                              style={{
                                top: "28px",
                                right: "20px",
                                cursor: "pointer",
                              }}
                            >
                              <CalenderIcon />
                            </span>
                          </Label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          }

          {setIsOCRFilter ? <div className="hsn-check-main-container mb-4 mt-4">
            <label htmlFor="Stage" className="royaltyLabel ms-3">
              Generated by OCR
            </label>
            <div className="questions-toggle ms-3">
              <div className="toggleFilterMainDiv">
                <div className="toggleFilterInnerDiv">
                  <ToggleSwitch
                    handleToggleChange={handleToggleOCR}
                    isChecked={isOCRFilter}
                  />
                </div>
              </div>
            </div>
          </div> : ""}

          {/* Approval  */}
          <div className="mt-2 ml-1">
            <h4>Approval</h4>
            <div>
              <RadioContainer
                optionsList={APPROVAL_RADIO_OPTIONS}
                handleSetRadioValue={handleSetApprovalRadioValue}
                radioValue={approvalValue}
                alignment="vertical"
                backGround={true}
              />
            </div>
          </div>
          {/* File Attachment   */}
          <div className="mt-4 ml-1">
            <h4>File Attachments</h4>
            <div>
              <RadioContainer
                optionsList={ATTACHMENT_RADIO_OPTIONS}
                handleSetRadioValue={handleSetAttachmentRadioValue}
                radioValue={attachmentValue}
                alignment="vertical"
                backGround={true}
              />
            </div>
          </div>
          {/* Comment */}
          <div className="mt-4 ml-1">
            <h4>Comment</h4>
            <div>
              <RadioContainer
                optionsList={COMMENT_RADIO_OPTIONS}
                handleSetRadioValue={handleSetCommentRadioValue}
                radioValue={commentValue}
                alignment="vertical"
                backGround={true}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end pb-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
            disabled={isApplyDisabled}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
}

export default Filter